<template>
    <v-container color="primary">
        <v-row>
            <v-col>
                <MaterialfyApiSave />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {
    name: "ApiSaveView",
    data: () => ({
        title: 'Api Save'
    }),
    mounted() { },

    methods: { },
};
</script>

<style></style>
